import { Database } from "lucide-react"
import { useEffect, useState } from "react"
import type { IconType } from "react-icons"
import { getPhosphorFillIcon, loadPhosphorIcons } from "./phosphorFillIcons"

type CollectionMenuIconProps = {
  menuIcon?: string
  className?: string
}

export function CollectionMenuIcon({ menuIcon, className }: CollectionMenuIconProps) {
  const [icon, setIcon] = useState<{ Comp: IconType } | null>(null)

  useEffect(() => {
    let cancelled = false
    if (!menuIcon?.trim()) {
      setIcon(null)
      return
    }
    loadPhosphorIcons().then((icons) => {
      if (cancelled) return
      const Comp = getPhosphorFillIcon(icons, menuIcon)
      setIcon(Comp ? { Comp } : null)
    })
    return () => {
      cancelled = true
    }
  }, [menuIcon])

  if (!icon) {
    return <Database className={className} aria-hidden />
  }
  const Comp = icon.Comp
  return <Comp className={className} aria-hidden />
}
